<template>
	<div class="WallIntegrationsOverview">
		<h3>Wall Integrations</h3>
		<div v-for="integration in integrations" :key="integration.name">
			{{integration.name}}
		</div>
	</div>
</template>

<script setup>

//NOTE: Could not test b/c this page is disabled.

import {reactive} from "vue";

let integrations = reactive([
	{
		name: "Twilio",
		type: "SMS"
	}
])


</script>

<style scoped>
.routeFade-enter-active, .routeFade-leave-active {
  transition: opacity .5s ease;
}

.routeFade-leave-from {
  opacity: 1;
}

.routeFade-enter-from, .routeFade-leave-to, .routeFade-leave-active {
  opacity: 0;
}

</style>